/*
  Colour dots on vg-landing-card (cards with a linked product).

  Clicking a dot shows that colour's image on the card and points the card's
  Personalise link at the product with ?colour=<value>, which vg-tag-pdp.js
  preselects. One delegated listener, so it survives the theme editor
  re-rendering the section. Without JS the dots do nothing and the link opens
  the product with no colour chosen.
*/
(function () {
  if (window.vgLandingCardColours) return;
  window.vgLandingCardColours = true;

  var SLIDE_MS = 450;
  var preloaded = {};
  var reducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  // Slide the new colour in from the side its dot sits on relative to the
  // current one (a dot further right enters from the right), like a carousel.
  // The incoming image is decoded first so nothing slides in blank, and a
  // newer click supersedes an older one that is still decoding.
  function showImage(card, media, toIndex, src, alt) {
    var fromIndex = parseInt(card.getAttribute('data-colour-index') || '0', 10);
    if (toIndex === fromIndex) return;
    card.setAttribute('data-colour-index', String(toIndex));
    var token = (card._vgSlideToken || 0) + 1;
    card._vgSlideToken = token;

    // Finish any slide still running before starting the next one.
    if (card._vgSlideDone) card._vgSlideDone();
    Array.prototype.forEach.call(media.querySelectorAll('img[data-slide-leaving]'), function (img) {
      img.remove();
    });
    var current = media.querySelector('img');
    if (!current) return;

    var incoming = current.cloneNode(false);
    incoming.removeAttribute('srcset');
    incoming.removeAttribute('loading');
    incoming.removeAttribute('style');
    incoming.classList.remove('vg-landing-card__slide');
    incoming.src = src;
    if (alt) incoming.alt = alt;

    var decoded = incoming.decode ? incoming.decode().catch(function () {}) : Promise.resolve();
    decoded.then(function () {
      if (card._vgSlideToken !== token || !current.isConnected) return;
      if (reducedMotion.matches) {
        current.replaceWith(incoming);
        return;
      }
      if (typeof incoming.animate !== 'function') {
        current.replaceWith(incoming);
        return;
      }
      var direction = toIndex > fromIndex ? 1 : -1;
      var timing = { duration: SLIDE_MS, easing: 'cubic-bezier(.22,.7,.2,1)', fill: 'both' };
      incoming.classList.add('vg-landing-card__slide');
      current.classList.add('vg-landing-card__slide');
      current.setAttribute('data-slide-leaving', '');
      current.after(incoming);
      var enter = incoming.animate(
        [{ transform: 'translateX(' + direction * 100 + '%)' }, { transform: 'translateX(0)' }],
        timing
      );
      var leave = current.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(' + -direction * 100 + '%)' }],
        timing
      );

      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        card._vgSlideDone = null;
        leave.cancel();
        current.remove();
        enter.cancel();
        incoming.classList.remove('vg-landing-card__slide');
      }
      card._vgSlideDone = done;
      enter.finished.then(done, done);
    });
  }

  function preload(swatches) {
    swatches.forEach(function (swatch) {
      var src = swatch.getAttribute('data-image');
      if (!src || preloaded[src]) return;
      preloaded[src] = true;
      new Image().src = src;
    });
  }

  function cardSwatches(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-card-swatch]'));
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.vg-landing-card');
    if (!card) return;

    cardSwatches(card).forEach(function (other) {
      other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
    });

    var media = card.querySelector('.vg-landing-card__media');
    var src = swatch.getAttribute('data-image');
    if (media && src) {
      showImage(card, media, cardSwatches(card).indexOf(swatch), src, swatch.getAttribute('data-alt'));
    }

    var link = card.querySelector('[data-card-link]');
    var href = swatch.getAttribute('data-href');
    if (link && href) link.setAttribute('href', href);
  });

  // Fetch a card's colour images as soon as the visitor reaches for its dots,
  // so the swap is instant on click. Mouse hover and keyboard focus only: a
  // touch fires pointerover on every tap, which would fetch all colours on a
  // phone just for scrolling past.
  ['pointerover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var group = event.target.closest && event.target.closest('.vg-landing-card--colours');
      if (group) preload(cardSwatches(group));
    });
  });
})();
